import React, { useLayoutEffect } from 'react';
import { Pressable, View } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { CloseSmallIcon } from '@/assets/icons/CloseSmallIcon';
import { Box } from '@/components/lib/components';

type Props = {
    // Center slot — mirrors CheckoutHeader's balanceButton prop
    balanceButton: React.ReactNode;
    // Right slot — mirrors CheckoutHeader's rightItem prop; omit to leave the slot empty
    rightItem?: React.ReactNode;
    onRightItemPress?: () => void;
    // Override the default goBack() behaviour of the X button
    onClose?: () => void;
};

// Headless component — renders null in the view tree.
// Drops into any screen whose native stack has headerShown: true and wires up
// X | balanceButton | rightItem via navigation.setOptions.
export const NativeCheckoutHeader = ({ balanceButton, rightItem, onRightItemPress, onClose }: Props) => {
    const navigation = useNavigation();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => (
                <Pressable onPress={onClose ?? (() => navigation.goBack())} hitSlop={12}>
                    <CloseSmallIcon />
                </Pressable>
            ),
            headerTitle: () => (
                // View wrapper prevents Android from stretching headerTitle to full width
                <View style={{ alignSelf: 'center' }}>{balanceButton}</View>
            ),
            headerRight: rightItem
                ? () => (
                      <Pressable onPress={onRightItemPress} hitSlop={20}>
                          <Box padding="s4">{rightItem}</Box>
                      </Pressable>
                  )
                : undefined,
        });
    }, [navigation, balanceButton, rightItem, onRightItemPress, onClose]);

    return null;
};
